<template>
  <RecordingModal />
  <div class="recordings-card card mb-25 border-0 radius-7 bg-white letter-spacing">
    <div class="recordings-card-body card-body p-15 p-sm-20 p-md-25 p-lg-30">
      <div class="container-title-date mb-40">
        <h5 class="ml-5 mb-4">Selecione a camera</h5> 

        <div class="recordings-filters" aria-label="Filtros de cameras">
          <div class="recordings-filter-field">
            <label for="recordings-client-filter">Cliente</label>
            <select
              id="recordings-client-filter"
              v-model="selectedClient"
              class="form-select"
              :disabled="isLoading"
              @change="applyFilters"
            >
              <option value="">Todos os clientes</option>
              <option v-for="client in clientOptions" :key="client.value" :value="client.value">
                {{ client.label }}
              </option>
            </select>
          </div>

          <div class="recordings-filter-field">
            <label for="recordings-days-filter">Dias de gravacao</label>
            <select
              id="recordings-days-filter"
              v-model="selectedStorageDays"
              class="form-select"
              :disabled="isLoading"
              @change="applyFilters"
            >
              <option value="">Todos os periodos</option>
              <option v-for="days in storageDaysOptions" :key="days" :value="days">
                {{ formatStorageDaysOption(days) }}
              </option>
            </select>
          </div>

          <div class="recordings-filter-field">
            <label for="recordings-quality-filter">Qualidade</label>
            <select
              id="recordings-quality-filter"
              v-model="selectedQuality"
              class="form-select"
              :disabled="isLoading"
              @change="applyFilters"
            >
              <option value="">Todas as qualidades</option>
              <option v-for="quality in qualityOptions" :key="quality" :value="quality">
                {{ quality }}
              </option>
            </select>
          </div>

          <button
            v-if="hasActiveFilters"
            type="button"
            class="clear-filters-button"
            :disabled="isLoading"
            @click="clearFilters"
          >
            Limpar filtros
          </button>
        </div>

        <div class="recordings-table-wrapper table-responsive mt-4">
          <table class="recordings-table table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  Imagem
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Nome
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Cliente
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Conexão
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Gravando
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Tempo
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Qualidade
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                >
                  Ação
                </th>
              </tr>
            </thead>

            <tbody>
              <tr 
                v-for="(value, index) in getRecordingCameras"
                :key="value.id || value.uuid || `${currentPage}-${index}`"
                class="cursor-pointer"
                data-bs-toggle="modal"
                data-bs-target="#RecordingModal"
                @click="setRecordingOnModal(value)"
              >
                <th
                  class="camera-image-cell shadow-none lh-1 fw-medium text-black-emphasis title ps-0"
                  data-label="Imagem"
                >
                  <div
                    class="d-flex align-items-center fs-md-15 fs-lg-16 fw-medium"
                  >
                    <img
                      class="radius-7 img-table-camera"
                      :src="getCameraThumbnail(value)"
                      @error="setDefaultCameraThumbnail"
                      alt="Camera"
                      width="200"
                    />
                  </div>
                </th>
                <td class="camera-name-cell shadow-none lh-1 fw-medium text-black-emphasis" data-label="Nome">
                  {{ value.name }}
                </td>
                <td class="camera-detail-cell shadow-none lh-1 fw-medium text-black-emphasis" data-label="Cliente">
                  {{ getCameraClient(value) }}
                </td>
                <td class="camera-detail-cell shadow-none lh-1 fw-medium text-black-emphasis" data-label="Conexão">
                  {{ getCameraConnection(value) }}
                </td>
                <td
                  class="camera-detail-cell camera-recording-cell shadow-none lh-1 fw-medium text-black-emphasis"
                  :class="value.record == 1 ? 'is-recording' : 'is-not-recording'"
                  data-label="Gravando"
                >
                  {{ value.record == 1 ? "Sim" : "Nao" }}
                </td>
                <td class="camera-detail-cell shadow-none lh-1 fw-medium text-black-emphasis" data-label="Tempo">
                  {{ getCameraStorageDuration(value) }}
                </td>
                <td class="camera-detail-cell shadow-none lh-1 fw-medium text-black-emphasis" data-label="Qualidade">
                  {{ getCameraQuality(value) }}
                </td>
                <td class="camera-action-cell shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" data-label="Ação">
                  <button
                    type="button"
                    class="play-recording-button"
                    data-bs-toggle="modal"
                    data-bs-target="#RecordingModal"
                    aria-label="Abrir gravacoes"
                    title="Abrir gravacoes"
                    @click.stop="setRecordingOnModal(value)"
                  >
                    <i class="ph ph-play"></i>
                  </button>
                </td>
              </tr>
              <tr v-if="isLoading && getRecordingCameras.length === 0" class="recordings-empty-row">
                <td colspan="8">
                  Carregando cameras...
                </td>
              </tr>
              <tr v-else-if="loadError && getRecordingCameras.length === 0" class="recordings-empty-row">
                <td colspan="8">
                  Nao foi possivel carregar as cameras. Tente novamente.
                </td>
              </tr>
              <tr v-else-if="getRecordingCameras.length === 0" class="recordings-empty-row">
                <td colspan="8">
                  Nenhuma camera encontrada com os filtros selecionados.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="totalPages > 1" class="recordings-pagination" aria-label="Paginacao de cameras">
          <span class="recordings-pagination-summary">
            {{ paginationSummary }}
          </span>
          <div class="recordings-pagination-controls">
            <button
              type="button"
              class="recordings-page-button recordings-page-navigation"
              :disabled="isLoading || currentPage === 1"
              aria-label="Pagina anterior"
              @click="goToPage(currentPage - 1)"
            >
              <i class="ph ph-caret-left"></i>
            </button>
            <button
              v-for="page in visiblePages"
              :key="page"
              type="button"
              class="recordings-page-button"
              :class="{ active: page === currentPage }"
              :disabled="isLoading"
              :aria-label="`Ir para pagina ${page}`"
              :aria-current="page === currentPage ? 'page' : undefined"
              @click="goToPage(page)"
            >
              {{ page }}
            </button>
            <button
              type="button"
              class="recordings-page-button recordings-page-navigation"
              :disabled="isLoading || currentPage === totalPages"
              aria-label="Proxima pagina"
              @click="goToPage(currentPage + 1)"
            >
              <i class="ph ph-caret-right"></i>
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { mapGetters, mapActions } from 'vuex';

import moment from 'moment';
import RecordingModal from './RecordingModal.vue';
import 'video.js/dist/video-js.css';
import defaultCameraThumbnail from '../../assets/images/camera-placeholder.svg';


export default defineComponent({
  name: "RecentFiles",
  data () {
    return {
      modalKey: 0,
      selectedClient: '',
      selectedStorageDays: '',
      selectedQuality: '',
      isLoading: false,
      loadError: false,
      requestSequence: 0
    }
  },
  components: {
    RecordingModal,
  },
  computed: {
    ...mapGetters([
      'getRecordings',
      'getRecordingsPagination',
      'getIndexRecordSearch',
      'getRecordingCameras',
      'getRecordingCamerasPagination',
      'getRecordingCameraFilters',
      'getCurrentSearchCamera',
      'getCurrentRecording'
    ]),
    clientOptions() {
      return this.getRecordingCameraFilters.clients || [];
    },
    storageDaysOptions() {
      return this.getRecordingCameraFilters.storage_days || [];
    },
    qualityOptions() {
      return this.getRecordingCameraFilters.qualities || [];
    },
    currentPage() {
      return this.getRecordingCamerasPagination.current_page || 1;
    },
    totalPages() {
      return this.getRecordingCamerasPagination.last_page || 1;
    },
    visiblePages() {
      const firstPage = Math.max(1, Math.min(this.currentPage - 1, this.totalPages - 2));
      const lastPage = Math.min(this.totalPages, firstPage + 2);

      return Array.from({ length: lastPage - firstPage + 1 }, (_, index) => firstPage + index);
    },
    paginationSummary() {
      const pagination = this.getRecordingCamerasPagination;

      if (!pagination.total) return '0 cameras';

      return `${pagination.from}-${pagination.to} de ${pagination.total} cameras`;
    },
    hasActiveFilters() {
      return Boolean(this.selectedClient || this.selectedStorageDays || this.selectedQuality);
    }
  },
  async mounted(){
    await this.loadRecordingCameras(1, true);
  },
  methods: {
    ...mapActions([
        "setRecordings",
        "setCurrentRecording",
        "setRecordingShowModalState",
        "setRecordingCameras",
        "setCurrentSearchCamera"
    ]),
    async loadRecordingCameras(page = 1, includeFilters = false) {
      const requestId = ++this.requestSequence;
      const params = { page };

      if (includeFilters) params.include_filters = 1;
      if (this.selectedClient) params.client_id = this.selectedClient;
      if (this.selectedStorageDays) params.storage_days = this.selectedStorageDays;
      if (this.selectedQuality) params.quality = this.selectedQuality;

      this.isLoading = true;
      this.loadError = false;

      try {
        await this.setRecordingCameras(params);
      } catch (error) {
        if (requestId === this.requestSequence) {
          this.loadError = true;
        }
      } finally {
        if (requestId === this.requestSequence) {
          this.isLoading = false;
        }
      }
    },
    applyFilters() {
      this.loadRecordingCameras(1);
    },
    setRecordingOnModal(currentRecording){
      // this.setRecordingShowModalState(true);

      // this.modalKey++;
      // currentRecording.key = this.modalKey;

      this.setCurrentRecording([currentRecording]);
    },
    getCameraThumbnail(camera) {
      return camera.thumbnail || defaultCameraThumbnail;
    },
    setDefaultCameraThumbnail(event) {
      event.target.onerror = null;
      event.target.src = defaultCameraThumbnail;
    },
    getFirstValue(camera, fields) {
      if (!camera) return null;

      const field = fields.find((key) => {
        const value = key.split('.').reduce((obj, part) => obj && obj[part], camera);
        return value !== undefined && value !== null && value !== '';
      });

      return field ? field.split('.').reduce((obj, part) => obj && obj[part], camera) : null;
    },
    formatCameraValue(value) {
      if (value === undefined || value === null || value === '') return null;

      if (typeof value === 'object') {
        return value.name || value.company_name || value.client_name || value.quality || value.category || value.title || null;
      }

      return value;
    },
    getCameraClient(camera) {
      return this.formatCameraValue(this.getFirstValue(camera, [
        'company_name',
        'client_name',
        'customer_name',
        'company',
        'client',
        'customer'
      ])) || '-';
    },
    getCameraConnection(camera) {
      const protocol = this.formatCameraValue(this.getFirstValue(camera, [
        'protocol',
        'protocol_id',
        'camera_protocol_id',
        'connection_type_id',
        'protocol_name',
        'protocol_type',
        'camera_protocol',
        'source_protocol',
        'connection_protocol',
        'connection_type',
        'connection',
        'type_connection',
        'stream_protocol',
        'stream_type',
        'input_type',
        'input_protocol',
        'ingest_protocol',
        'source_type'
      ]));

      if (protocol === 1 || protocol === '1') return 'RTMP';
      if (protocol === 2 || protocol === '2') return 'RTSP';

      if (typeof protocol === 'string') {
        return protocol.toUpperCase();
      }

      const hasRtspConfig = Boolean(this.getFirstValue(camera, [
        'rtsp',
        'rtsp_url',
        'url_rtsp',
        'ddns_ip_rtsp',
        'port_rtsp',
        'user_rtsp',
        'password_rtsp',
        'channel_rtsp',
        'stream_rtsp',
        'manufacturer'
      ]));

      if (hasRtspConfig) return 'RTSP';

      const hasRtmpConfig = Boolean(this.getFirstValue(camera, [
        'rtmp',
        'rtmp_url',
        'url_rtmp',
        'stream_key',
        'rtmp_key'
      ]));

      if (hasRtmpConfig) return 'RTMP';

      const url = camera.url || '';
      if (url.startsWith('rtmp')) return 'RTMP';
      if (url.startsWith('rtsp')) return 'RTSP';
      if (url !== '') return 'RTMP';

      return '-';
    },
    getCameraStorageDuration(camera) {
      if (camera.record != 1) return 'Sem gravacao';

      const days = this.getCameraStorageDaysValue(camera);

      if (days === '') return '-';
      if (Number(days) === 1) return '1 dia';

      return `${days} dias`;
    },
    getCameraStorageDaysValue(camera) {
      if (camera.record != 1) return '';

      const days = this.formatCameraValue(this.getFirstValue(camera, [
        'storage_duration',
        'recording_storage_duration',
        'storage_period',
        'recording_storage_days',
        'recording_days',
        'record_days',
        'days_recording',
        'retention_days',
        'retention_period',
        'retention_duration',
        'recording_retention_days',
        'storage_days',
        'days',
        'period',
        'plan.days',
        'plan.storage_duration'
      ]));

      return days === null ? '' : String(days);
    },
    getCameraQuality(camera) {
      const quality = this.formatCameraValue(this.getFirstValue(camera, [
        'quality',
        'video_quality',
        'recording_quality',
        'record_quality',
        'quality_name',
        'quality_type',
        'resolution',
        'resolution_name',
        'recording_resolution',
        'image_quality',
        'plan_quality',
        'price_category',
        'category',
        'category_name',
        'storage_quality',
        'camera_quality',
        'plan.quality',
        'plan.category'
      ]));

      if (typeof quality === 'string') {
        return quality.toUpperCase();
      }

      return quality || '-';
    },
    formatStorageDaysOption(days) {
      return Number(days) === 1 ? '1 dia' : `${days} dias`;
    },
    clearFilters() {
      this.selectedClient = '';
      this.selectedStorageDays = '';
      this.selectedQuality = '';
      this.loadRecordingCameras(1);
    },
    goToPage(page) {
      const targetPage = Math.min(Math.max(page, 1), this.totalPages);

      if (targetPage !== this.currentPage) {
        this.loadRecordingCameras(targetPage);
      }
    },
    searchRecordings(
    ){
        
        const input = document.getElementById("basicCalendar") ;
        const index_origin = document.getElementById("index_origin") ;

        if(input.value == ""){
          return;
        }

        let initDate = "";
        let endDate = "";

        if(input.value.includes(" até ")){
          const newDate = input.value.split(" até ");
          initDate = moment(newDate[0], "DD/MM/YYYY").format("YYYY-MM-DD");
          endDate = moment(newDate[1], "DD/MM/YYYY").format("YYYY-MM-DD");
        } else {
          initDate = moment(input.value, "DD/MM/YYYY").format("YYYY-MM-DD");
          endDate = moment(input.value, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
        
        const filter = {
            "dateInit": initDate,
            "dateEnd": endDate,
            "index": index_origin.value
        }

        this.currentPage = 0;

        const buttonSearchRecordingsApi = document.getElementById("buttonSearchRecordingsApi") ;
        buttonSearchRecordingsApi.disabled = true;
        buttonSearchRecordingsApi.innerHTML = "Buscando...";

        this.setRecordings(filter).then(() => {
          buttonSearchRecordingsApi.disabled = false;
          buttonSearchRecordingsApi.innerHTML = "Pesquisar";
        });
    }
  }
});
</script>

<style scoped>

.recordings-filters {
  display: grid;
  grid-template-columns: repeat(3, minmax(170px, 1fr)) auto;
  gap: 12px;
  align-items: end;
  padding: 16px;
  border: 1px solid #ececf3;
  border-radius: 10px;
  background-color: #fafaff;
}

.recordings-filter-field label {
  display: block;
  margin-bottom: 6px;
  color: #77778d;
  font-size: 12px;
  font-weight: 600;
}

.recordings-filter-field .form-select {
  min-height: 40px;
  border-color: #dedee9;
  border-radius: 7px;
  color: #38384f;
  font-size: 13px;
  box-shadow: none;
}

.recordings-filter-field .form-select:focus {
  border-color: #5d5fef;
  box-shadow: 0 0 0 3px rgba(93, 95, 239, 0.12);
}

.clear-filters-button {
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid #dedee9;
  border-radius: 7px;
  color: #5d5fef;
  background-color: #fff;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.clear-filters-button:hover,
.clear-filters-button:focus {
  border-color: #5d5fef;
  background-color: rgba(93, 95, 239, 0.06);
}

.recordings-empty-row td {
  padding: 32px 16px !important;
  color: #77778d;
  text-align: center;
}

.recordings-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 18px;
}

.recordings-pagination-summary {
  color: #77778d;
  font-size: 13px;
}

.recordings-pagination-controls {
  display: flex;
  gap: 6px;
}

.recordings-page-button {
  width: 34px;
  height: 34px;
  padding: 0;
  border: 1px solid #dedee9;
  border-radius: 7px;
  color: #53536a;
  background-color: #fff;
  font-size: 13px;
}

.recordings-page-button:hover:not(:disabled),
.recordings-page-button:focus:not(:disabled),
.recordings-page-button.active {
  border-color: #5d5fef;
  color: #fff;
  background-color: #5d5fef;
}

.recordings-page-button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

:global(.dark) .recordings-filters {
  border-color: #45445e;
  background-color: #343348;
}

:global(.dark) .recordings-filter-field .form-select,
:global(.dark) .clear-filters-button,
:global(.dark) .recordings-page-button {
  border-color: #55546c;
  color: #e5e5ed;
  background-color: #2b2a3f;
}

.img-table-camera {
    height: 50px;
    width: 90px !important;
}

.play-recording-button {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 4px;
  color: #fff;
  background-color: #2B2A3F;
}

.play-recording-button:hover,
.play-recording-button:focus {
  background-color: #5D5FEF;
}

.play-recording-button i {
  font-size: 16px;
  line-height: 1;
}

@media (max-width: 768px) {
  .recordings-card {
    margin-right: -15px;
    margin-bottom: 0 !important;
    margin-left: -15px;
    border-radius: 0 !important;
  }

  .recordings-card .container-title-date {
    margin-bottom: 0 !important;
  }

  .recordings-card-body {
    padding-right: 8px !important;
    padding-left: 8px !important;
  }

  .recordings-filters {
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 12px;
  }

  .clear-filters-button {
    width: 100%;
  }

  .recordings-pagination {
    flex-direction: column;
    gap: 10px;
  }

  .recordings-table-wrapper {
    overflow-x: visible;
  }

  .recordings-table {
    display: block;
    white-space: normal !important;
  }

  .recordings-table thead {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .recordings-table tbody {
    display: grid;
    gap: 8px;
  }

  .recordings-table tbody tr {
    position: relative;
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    column-gap: 8px;
    row-gap: 5px;
    padding: 10px;
    border: 1px solid #e3e4ef;
    border-radius: 10px;
    background: linear-gradient(145deg, #fff 0%, #fcfcff 100%);
    box-shadow: 0 2px 7px rgba(43, 42, 63, 0.035);
  }

  .recordings-table tbody .recordings-empty-row {
    display: block;
  }

  .recordings-table tbody .recordings-empty-row td {
    display: block;
    padding: 24px 12px !important;
    text-align: center !important;
  }

  .recordings-table tbody tr:active {
    background: #f8f8ff;
  }

  .recordings-table tbody th,
  .recordings-table tbody td {
    display: block;
    width: auto;
    min-width: 0;
    padding: 0;
    border: 0;
    line-height: 1.25 !important;
    text-align: left !important;
    white-space: normal;
  }

  .recordings-table .camera-image-cell {
    grid-column: 1 / 4;
    grid-row: 1 / 3;
    padding: 0;
  }

  .recordings-table .camera-name-cell {
    grid-column: 4 / 13;
    grid-row: 1;
    align-self: end;
    padding-right: 38px;
    color: #38384f !important;
    font-size: 14px;
    font-weight: 600 !important;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .recordings-table .camera-name-cell::before {
    display: none;
  }

  .recordings-table .camera-detail-cell {
    grid-row: 3;
    padding: 5px 6px;
    border: 0;
    border-radius: 7px;
    color: #53536a !important;
    font-size: 12px;
  }

  .recordings-table .camera-detail-cell::before {
    display: block;
    margin-bottom: 2px;
    color: #8a8aa3;
    font-size: 8px;
    font-weight: 500;
    line-height: 1.2;
    text-transform: uppercase;
    content: attr(data-label);
  }

  .recordings-table .camera-image-cell + .camera-name-cell + .camera-detail-cell {
    grid-column: 4 / 13;
    grid-row: 2;
    align-self: start;
    padding: 0;
    border: 0;
    color: #77778d;
    font-size: 11px;
    overflow-wrap: anywhere;
  }

  .recordings-table .camera-image-cell + .camera-name-cell + .camera-detail-cell::before {
    display: inline;
    margin: 0 4px 0 0;
    font-size: 9px;
    content: "Cliente:";
  }

  .recordings-table .camera-detail-cell:nth-of-type(3) {
    grid-column: 1 / 4;
    background-color: rgba(93, 95, 239, 0.055);
  }

  .recordings-table .camera-detail-cell:nth-of-type(4) {
    grid-column: 4 / 7;
    background-color: rgba(120, 120, 145, 0.055);
  }

  .recordings-table .camera-detail-cell:nth-of-type(5) {
    grid-column: 7 / 10;
    background-color: rgba(66, 139, 202, 0.055);
  }

  .recordings-table .camera-detail-cell:nth-of-type(6) {
    grid-column: 10 / 13;
    background-color: rgba(108, 99, 190, 0.05);
  }

  .recordings-table .camera-recording-cell.is-recording {
    color: #277757 !important;
    background-color: rgba(32, 160, 105, 0.075);
  }

  .recordings-table .camera-action-cell {
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 0;
  }

  .img-table-camera {
    display: block;
    box-sizing: border-box;
    height: 52px;
    width: 82px !important;
    max-width: 100% !important;
    border: 1px solid #e5e8f0;
    background-color: #f3f5fb;
    object-fit: cover;
  }

  .play-recording-button {
    width: 34px;
    height: 34px;
    border-radius: 7px;
  }

  :global(.dark) .recordings-table tbody tr {
    border-color: #45445e;
    background: #343348;
    box-shadow: none;
  }

  :global(.dark) .recordings-table .camera-name-cell {
    color: #f2f2f7 !important;
  }

  :global(.dark) .recordings-table .camera-detail-cell {
    color: #d9d8e4 !important;
    background-color: rgba(255, 255, 255, 0.045);
  }

  :global(.dark) .recordings-table .camera-recording-cell.is-recording {
    color: #7ed9ad !important;
    background-color: rgba(52, 199, 127, 0.1);
  }
}

</style>
